import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { updateProfile } from '../../../store/actions/influencerActions';
import {
  deleteAccount,
  updatePaypalInfo
} from '../../../store/actions/userProfileActions';
import scriptLoader from 'react-async-script-loader';

const styles = theme => ({
  layout: {
    width: '100%',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      boxSizing: 'border-box'
    }
  },
  root: {
    width: '100%',
    minHeight: '500px'
  },
  leftPageDiv: {
    width: '250px',
    overflow: 'hidden',
    minHeight: '50px',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  otherPage: {
    padding: '20px',
    width: '100%'
  },
  profile_info: {
    padding: 0
  },
  profile__header: {
    background: '#e7e8ea',
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 30,
    paddingRight: 30
  },
  profileContent: {
    position: 'relative'
  },
  section: {
    paddingTop: 15,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 30
  },
  deleteCancelButtons: {
    width: '85px'
  },
  deleteAcceptButtons: {
    width: '85px',
    float: 'right'
  },
  deleteButtonsContainer: {
    marginTop: '50px'
  },
  button: {
    color: '#ffffff'
  },
  listIcon: {
    minWidth: '36px'
  },
  settingsOverlay: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    background: 'white',
    zIndex: 10,
    opacity: '.5'
  },
  manageStripeText: {
    color: '#22c26e',
    cursor: 'pointer'
  },
  hidden_profile_info: {
    display: 'none'
  },
  paypalButtonContainer: {
    width: '230px',
    margin: '0 auto'
  },
  paypalCheck: {
    color: 'green',
    marginBottom: '5px',
    marginRight: '10px'
  },
  paypalField: {
    fontWeight: 'bold'
  },
  paypalFieldContainer: {
    marginTop: '30px'
  },
  paypalFieldContainerText: {
    marginTop: '30px',
    marginBottom: '10px'
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  select: {
    width: '250px',
    marginTop: '0px',
    background: 'white',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  ageInput: {
    width: '100px'
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleUpdateProfile: newProfile => dispatch(updateProfile(newProfile)),
    handleUpdatePaypalInfo: paypalInfo =>
      dispatch(updatePaypalInfo(paypalInfo)),
    handleDeleteAccount: newProfile => dispatch(deleteAccount(newProfile))
  };
};

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  withProps(({ auth, profile }) => ({
    auth,
    profile
    // campaigns
  })),
  withStyles(styles),
  // Add props.router (used in handlers)
  withRouter,
  scriptLoader(['https://www.paypalobjects.com/js/external/connect/api.js'])
);



// WEBPACK FOOTER //
// ./src/components/influencer/settings/InfluencerSettings.enhancer.js